import React, { RefObject, useRef, useState } from 'react';
import './style.scss';
import { FontAwesomeConfigurations } from '../../../utils/Configuration/FontAwesomeConfiguration';
import JUNOActionMenu from '../../components/JUNOActionMenu/index';
import JUNONotificationDisplay from '../../components/JUNONotificationDisplay';
import { motion } from 'framer-motion';
import { Accessibility } from '../../../utils/Accessibility/Accessibility';
import useOutsideAlerter from '../../hooks/useOutsideAlerter';
import { useEffect } from 'react';
export interface NotificationModuleProps {
  onClick: Function;
  onPrefs: Function;
  onApiRequest: Function;
  description: string;
  icon?: string;
  id: number;
  image?: string;
  isRead: boolean;
  time: string;
  title: string;
  url: string;
  type: number;
  containerRef?: RefObject<HTMLDivElement>;
}

const NotificationModule: React.FC<NotificationModuleProps> = ({ ...props }) => {
  const [isRead, setIsRead] = useState(props.isRead);
  const [isOpen, setIsOpen] = useState(false);
  const wrapperRef = useRef(null);
  const [menuDirection, setMenuDirection] = useState('down');
  const onClickOpen = e => {
    if (!e.target?.classList.contains('checkmark_span') && e.target.type != 'checkbox') {
      Accessibility.actionMenuOpen = !isOpen;
      setIsOpen(old => !old);
    }
  };
  const onMarkAsRead = (aNotificationId, message) => {
    props
      .onApiRequest('../custom_api/api_Services_Notifications.php', {
        api: 'api_mark_notifications_read',
        notifications: [aNotificationId],
      })
      .then(() => {
        PubNubCenter.INSTANCE?.dispatch(PubNubCenter.ON_SOCIAL_NOTIFICATION_READ, this, message);
        setIsRead(true);
        setIsOpen(false);
      });
  };

  const onMarkAsUnread = aNotificationId => {
    props
      .onApiRequest('../custom_api/api_Services_Notifications.php', {
        api: 'api_mark_notifications_unread',
        notifications: [aNotificationId],
      })
      .then(() => {
        PubNubCenter.INSTANCE?.dispatch(PubNubCenter.ON_SOCIAL_NOTIFICATION_READ, this, {
          channel: App.INSTANCE.CurrentUser.ChatRoom,
          mark_read: false,
        });
        setIsRead(false);
        setIsOpen(false);
      });
  };

  useOutsideAlerter(wrapperRef, e => {
    // TODO this gets fired like 8x per click and the below stop doesnt affect it...however it does function properly
    e.stopPropagation();
    // console.log('react fired');
    setIsOpen(false);
  });

  const isClipped = (childRef: React.RefObject<HTMLElement>, parentRef: React.RefObject<HTMLElement>): boolean => {
    if (!childRef.current || !parentRef.current) {
      return false; // Either child or parent ref is not set
    }

    const childRect = childRef.current.getBoundingClientRect();
    const parentRect = parentRef.current.getBoundingClientRect();

    const isClipped = childRect.top + childRect.height > parentRect.bottom;

    console.log('isClipped', isClipped);
    return isClipped;
  };

  useEffect(() => {
    setTimeout(() => {
      if (isClipped(wrapperRef, props.containerRef!)) {
        setMenuDirection('up');
      } else {
        setMenuDirection('down');
      }
    }, 50);
  }, [isOpen]);

  let actionHeaders = [{ order: 0, text: CrowdHub_App.LANG.MANAGE_NOTIFICATIONS }];
  let actionItems = [
    {
      header: 0,
      order: 0,
      id: props.id,
      text: isRead ? CrowdHub_App.LANG.MARK_NOTIFICATIONS_UNREAD : CrowdHub_App.LANG.MARK_NOTIFICATIONS_READ,
      icon: FontAwesomeConfigurations.ICON_CIRCLE_CHECK,
      onclick: aNotificationId => {
        if (isRead) {
          onMarkAsUnread(aNotificationId);
        } else {
          onMarkAsRead(aNotificationId, {
            channel: App.INSTANCE.CurrentUser.ChatRoom,
            mark_read: true,
          });
        }
      },
    },
    {
      header: 0,
      order: 1,
      id: props.id,
      text: CrowdHub_App.LANG.DELETE_NOTIFICATION,
      icon: FontAwesomeConfigurations.ICON_TRASH_DUOTONE,
      onclick: aNotificationId => {
        props
          .onApiRequest('api_notifications_delete.php', {
            notification_id: aNotificationId,
          })
          .then(() => {
            App.INSTANCE.loadNotificationCount();
            $(`.notification_row_${aNotificationId}`).slideUp();
            setIsOpen(false);
          });
      },
    },
  ];

  if (!App.INSTANCE.isPhone()) {
    actionHeaders.push({ order: 1, text: 'Settings' });
    actionItems.push({
      header: 1,
      order: 0,
      id: props.id,
      text: 'Notification Preferences',
      icon: FontAwesomeConfigurations.ICON_GEAR_SOLID,
      onclick: () => {
        props.onPrefs();
      },
    });
  }

  return (
    <div key={props.id} className={`notification_module ${isRead ? '' : 'unread'}`}>
      <JUNONotificationDisplay {...props} onMarkAsRead={onMarkAsRead} />
      <div className="JUNO_action_menu">
        <motion.div
          key={`action_menu_${moment.now()}`}
          onClick={onClickOpen}
          className={`action_menu_icon ${isOpen ? 'open' : ''}`}
        >
          <i className={`${FontAwesomeConfigurations.ICON_ELLIPSIS_VERTICAL} fa-fw`} />
        </motion.div>
        {isOpen && <div className={`action_menu_mobile_bg`}></div>}
        <motion.div
          className={`action_menu_dropdown ${isOpen ? 'open' : ''} direction_${menuDirection}`}
          variants={dropdown}
          initial={`hidden`}
          animate={isOpen ? 'visible' : 'hidden'}
          style={{
            y: 12,
          }}
          ref={wrapperRef}
        >
          <JUNOActionMenu items={actionItems} headers={actionHeaders} mobile_props={props} />
        </motion.div>
      </div>
    </div>
  );
};

const dropdown = {
  hidden: {
    opacity: 0,
    transition: { duration: 0.15 },
    display: 'none',
  },
  visible: {
    y: 0,
    opacity: 1,
    transition: { duration: 0.15 },
    display: 'flex',
  },
};

export default NotificationModule;
